// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ErrorsController from "./errors_controller"
application.register("errors", ErrorsController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import ReportsController from "./reports_controller"
application.register("reports", ReportsController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import RegistrationTokenController from "./registration_token_controller"
application.register("registration-token", RegistrationTokenController)

import InvoiceItemPhotosController from "./invoice_item_photos_controller"
application.register("invoice-item-photos", InvoiceItemPhotosController)

import FeedbackGalleryController from "./feedback_gallery_controller";
application.register("feedback-gallery", FeedbackGalleryController);

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)
